import React from 'react';

import { Grid, InputLabelProps, SxProps, TextField, Theme } from '@mui/material';
import {
  DatePicker,
  DatePickerSlotsComponentsProps,
  DateValidationError,
} from '@mui/x-date-pickers';

interface TextFieldProps {
  value: unknown;
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, campo?: string) => void;
  defaultValue: unknown;
  error: boolean | undefined;
  helperText: React.ReactNode;
  style: React.CSSProperties | undefined;
  InputLabelProps: Partial<InputLabelProps> | undefined;
}

interface DatePickerProps {
  onChange: (date: Date | null, context?: any) => void;
  onError: ((error: DateValidationError, value: Date | null) => void) | undefined;
  slotProps: DatePickerSlotsComponentsProps<Date> | undefined;
  sx: SxProps<Theme> | undefined;
}

export interface ObservacaoProps {
  descricao: string | null;
  dataObservacao: Date | null;
}

interface Props {
  textField: TextFieldProps;
  datePicker: DatePickerProps;
  observacao: ObservacaoProps;
}

export default function Observacao({ textField, datePicker, observacao }: Props) {
  return (
    <Grid width="100%" container spacing={2}>
      <Grid item xs={6} md={10}>
        <TextField
          fullWidth
          type="text"
          name="descricao"
          id="descricao"
          label="Observação"
          variant="outlined"
          value={observacao.descricao}
          defaultValue={textField.defaultValue}
          onChange={(e) => textField.onChange(e, 'descricao')}
          error={textField.error}
          helperText={textField.helperText}
          style={textField.style}
          InputLabelProps={textField.InputLabelProps}
        />
      </Grid>
      <Grid item xs={6} md={2}>
        <DatePicker
          name="dataObservacao"
          label="Data"
          disableFuture
          value={observacao.dataObservacao ? new Date(observacao.dataObservacao) : null}
          onChange={(novaData) => datePicker.onChange(novaData)}
          onError={datePicker.onError}
          slotProps={datePicker.slotProps}
          sx={datePicker.sx}
        />
      </Grid>
    </Grid>
  );
}
